module.exports = __webpack_public_path__ + "static/media/main--1.52fb5203.png";